import { useMemo } from 'react';
import { ReactComponent as BlockedIcon } from '@elementary/common-ui/assets/20x20/blocked.svg';
import { ReactComponent as EditIcon } from '@elementary/common-ui/assets/20x20/edit.svg';
import { ReactComponent as DeleteIcon } from '@elementary/common-ui/assets/20x20/trash.svg';
import { Menu, IconButton } from '@elementary/common-ui/components';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

type Props = {
  onChange: (val: string) => void;
  isActive: boolean;
  isDefault?: boolean;
  isReorderable?: boolean;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
};

const RuleMenu = ({
  onChange,
  isActive,
  isDefault,
  isReorderable,
  canMoveUp,
  canMoveDown,
}: Props) => {
  const menuOptions = useMemo(
    () => [
      ...(isReorderable
        ? [
            {
              value: 'move-up',
              label: 'Move up',
              icon: <ArrowUpward fontSize="small" />,
              disabled: !canMoveUp,
            },
            {
              value: 'move-down',
              label: 'Move down',
              icon: <ArrowDownward fontSize="small" />,
              disabled: !canMoveDown,
            },
          ]
        : []),
      {
        value: isActive ? 'deactivate' : 'activate',
        label: isActive ? 'Deactivate' : 'Activate',
        icon: <BlockedIcon />,
      },
      {
        value: 'edit',
        label: 'Edit',
        icon: <EditIcon />,
      },
      {
        value: 'delete',
        label: 'Delete',
        icon: <DeleteIcon />,
        disabled: isDefault,
      },
    ],
    [isActive, isDefault, isReorderable, canMoveUp, canMoveDown],
  );

  return (
    <Menu
      menuButton={
        <IconButton
          aria-label="Rule actions"
          sx={{
            color: (theme) =>
              theme.tokens.components.iconButton.defaultColor ||
              theme.palette.content.primary,
            p: '2px !important',
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      }
      options={menuOptions}
      onChange={onChange}
      boldOptions
      closeOnChange
    />
  );
};

export default RuleMenu;
